import React, { Component } from 'react'
import { BadgeGate } from '../../common/permissions/badgeGate'
import { NavLink } from 'react-router-dom'
import classnames from 'classnames'

export interface Props {
  userId: string
  isDropdownActive: boolean
}

export class UserBannerDropdown extends Component<Props> {
  static displayName = 'UserBannerDropdown'

  render() {
    const { userId, isDropdownActive } = this.props

    return (
      <div
        className={classnames('user-banner__dropdown', {
          'user-banner__dropdown--hidden': !isDropdownActive,
        })}
        data-testid="user-banner-dropdown"
      >
        <h4 className="user-banner__dropdown-header">MANAGE USER</h4>
        <BadgeGate disableUI requiredBadges={['USERS', 'EDIT_USER']}>
          <NavLink
            data-test="user-banner-dropdown-link"
            className="user-banner__dropdown-link"
            to={`/users/${userId}/edit`}
          >
            Edit User Profile
          </NavLink>
          <NavLink
            data-test="user-banner-dropdown-link"
            className="user-banner__dropdown-link"
            to={`/users/${userId}/address`}
          >
            Manage User Addresses
          </NavLink>
        </BadgeGate>
      </div>
    )
  }
}
